import { View, Text } from '@react-pdf/renderer';
import theme from '../../../theme';
import { PdfDocumentProps } from './ExportPdf';
import formatNewLines from '../../../lib/helper/format-new-lines';

export type PdfCaseMessagesProps = Pick<PdfDocumentProps, 'caseMessages'>;

const PdfCaseMessages = ({ caseMessages: messages }: PdfCaseMessagesProps) => {
    return (
        <>
            {messages && (
                <>
                    <View
                        style={{
                            padding: 5,
                            width: '97%',
                            margin: 'auto',
                            borderRadius: '10',
                            fontSize: 15,
                            fontWeight: 'bold'
                        }}>
                        <Text>Case Messages</Text>
                    </View>
                    <View
                        style={{
                            padding: 5,
                            border: '2px solid black',
                            borderColor: theme.palette.appBackground.main,
                            width: '97%',
                            margin: 'auto',
                            borderRadius: '10',
                            fontSize: 8
                        }}>
                        <View
                            style={{
                                flexDirection: 'row',
                                borderBottom: '1.5px solid ' + theme.palette.appBackground.main,
                                borderColor: theme.palette.appBackground.main
                            }}>
                            <View style={{ width: '15%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>Send Date</Text>
                            </View>
                            <View style={{ width: '35%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>From</Text>
                            </View>
                            <View style={{ width: '50%', padding: 3 }}>
                                <Text style={{ fontWeight: 'bold' }}>Message</Text>
                            </View>
                        </View>
                        {messages.length > 0 ? (
                            messages.map((item, index) => (
                                <View
                                    key={item.id}
                                    style={{
                                        flexDirection: 'row',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderBottom:
                                            index !== messages.length - 1
                                                ? '1.5px solid ' + theme.palette.appBackground.main
                                                : '0px',
                                        borderColor: theme.palette.appBackground.main
                                    }}>
                                    <View style={{ width: '15%', padding: 3, fontSize: 7 }}>
                                        <Text>{item.displayCreatedDate}</Text>
                                        <Text>{item.displayCreatedTime}</Text>
                                    </View>
                                    <View style={{ width: '35%', padding: 3 }}>
                                        <Text>{item.createdBy}</Text>
                                    </View>
                                    <View style={{ width: '50%', padding: 3 }}>
                                        <Text>{formatNewLines(item.text)}</Text>
                                    </View>
                                </View>
                            ))
                        ) : (
                            <View
                                style={{
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: 10
                                }}>
                                <Text>No data</Text>
                            </View>
                        )}
                    </View>
                </>
            )}
        </>
    );
};

export default PdfCaseMessages;
